<div class="edit-parameter-page">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">EDITAR PARÁMETRO</h1>
                <p class="page-subtitle text-muted">
                    Actualice la información del parámetro y ajuste su estado
                </p>
            </div>
        </div>
    </div>

    <div class="page-content">
        <mat-card class="form-card">
            <mat-card-content>
                <!-- Loading state -->
                <div *ngIf="isLoadingParameter" class="loading-container">
                    <div class="loading-spinner">
                        <i class="ri-loader-4-line animate-spin"></i>
                        <p>Cargando datos del parámetro...</p>
                    </div>
                </div>

                <!-- Form content -->
                <form *ngIf="!isLoadingParameter && parameter" [formGroup]="parameterForm" (ngSubmit)="onSubmit()">
                    <!-- Información Básica -->
                    <div class="form-section">
                        <h6 class="section-title d-flex align-items-center mb-3">
                            <i class="ri-information-line me-2 text-primary"></i>
                            Información Básica
                        </h6>
                        
                        <div class="form-grid basic-grid">
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Clave</mat-label>
                                <input matInput [value]="parameter.key" disabled>
                                <mat-hint>La clave no se puede modificar</mat-hint>
                            </mat-form-field>

                            <!-- Input de archivo para MANUAL_USUARIO_PATH -->
                            <div *ngIf="isManualParameter" class="form-field full-width">
                                <label class="file-upload-label">
                                    <span class="label-text">Manual de Usuario (PDF)</span>
                                    <input 
                                        type="file" 
                                        accept="application/pdf" 
                                        (change)="onFileSelected($event)"
                                        [disabled]="isUploadingFile || isLoading"
                                        class="file-input">
                                    <div class="file-info" *ngIf="selectedFile">
                                        <i class="ri-file-pdf-line me-2"></i>
                                        <span>{{ selectedFile.name }}</span>
                                        <span class="file-size">({{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB)</span>
                                    </div>
                                    <div class="file-info" *ngIf="!selectedFile && parameter?.value">
                                        <i class="ri-file-pdf-line me-2"></i>
                                        <span>Archivo actual: {{ parameter.value }}</span>
                                    </div>
                                    <div class="file-hint">
                                        Seleccione un archivo PDF para actualizar el manual de usuario
                                    </div>
                                </label>
                                <mat-progress-spinner 
                                    *ngIf="isUploadingFile" 
                                    mode="indeterminate" 
                                    diameter="24"
                                    class="upload-spinner">
                                </mat-progress-spinner>
                            </div>

                            <!-- Input de texto normal para otros parámetros -->
                            <mat-form-field *ngIf="!isManualParameter" appearance="outline" class="form-field">
                                <mat-label>Valor</mat-label>
                                <input matInput formControlName="value" placeholder="5" inputmode="text">
                                <mat-error *ngIf="parameterForm.get('value')?.hasError('required')">
                                    {{ getErrorMessage('value') }}
                                </mat-error>
                                <mat-error *ngIf="parameterForm.get('value')?.hasError('maxlength')">
                                    {{ getErrorMessage('value') }}
                                </mat-error>
                                <mat-hint>Valor del parámetro</mat-hint>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-field full-width">
                                <mat-label>Descripción</mat-label>
                                <textarea matInput formControlName="description" rows="3" placeholder="Descripción del parámetro" inputmode="text"></textarea>
                                <mat-error *ngIf="parameterForm.get('description')?.hasError('maxlength')">
                                    {{ getErrorMessage('description') }}
                                </mat-error>
                            </mat-form-field>

                            <div class="form-field checkbox-field">
                                <mat-checkbox formControlName="isActive" color="primary">
                                    Parámetro Activo
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>

                    <!-- Botones de acción -->
                    <div class="form-actions">
                        <button type="button" mat-button (click)="onCancel()" [disabled]="isLoading">
                            <i class="ri-arrow-left-line me-2"></i>
                            Cancelar
                        </button>
                        <button type="submit" mat-raised-button color="primary" [disabled]="parameterForm.invalid || isLoading">
                            <span *ngIf="!isLoading">
                                <i class="ri-save-line me-2"></i>
                                Guardar Cambios
                            </span>
                            <span *ngIf="isLoading">
                                <i class="ri-loader-4-line animate-spin me-2"></i>
                                Guardando...
                            </span>
                        </button>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>

